import React from 'react';
import { useTranslation } from "react-i18next";
export const DelegateOfficer1 = ({ register, errors }) => {
    const { t } = useTranslation();

    return (
        <div className="row mt-4">
            <div className="col-md-6">
                <div className="form-group">
                    <input {...register("officer1.name")} type="text" className="form-control" name="officer1.name"  placeholder="NameText" />
                    <label htmlFor="name" className="float-label">{t('NameText')} <span className="text-danger"> *</span></label>
                    <div className="text-danger">
                        <div>{t(errors.officer1?.name?.message)}</div>
                    </div>
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <input  {...register("officer1.jobTitle", { required: false })} type="text" className="form-control" name="officer1.jobTitle" placeholder="OrganizationOrCompanyText" />
                    <label htmlFor="managerCompanyName" className="float-label">{t('JobTitleText')} <span className="text-danger"> *</span></label>
                    <div className="text-danger">
                        <div>{t(errors.officer1?.jobTitle?.message)}</div>
                    </div>
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group mb-0">
                    <textarea {...register("officer1.code")} placeholder="AddressText" className="form-control" cols="30" rows="1" name="officer1.code" ></textarea>
                    <label htmlFor="managerAddress" className="float-label">{t('CivilServantID')} <span className="text-danger"> *</span></label>
                    <div className="text-danger">
                        {t(errors.officer1?.code?.message)}
                    </div>
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <input {...register("officer1.phone")} type="tel" className="form-control" name="officer1.phone" placeholder="PhoneNumberText" />
                    <label htmlFor="managerPhone" className="float-label">{t('PhoneNumberText')} <span className="text-danger"> *</span></label>
                    <div className="text-danger">
                        <div>{t(errors.officer1?.phone?.message)}</div>
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                <div className="form-group">
                    <input {...register("officer1.email")} type="email" className="form-control" name="officer1.email" id="managerEmail" placeholder="EmailText" />
                    <label htmlFor="managerEmail" className="float-label">{t('EmailText')} <span className="text-danger"> *</span></label>
                    {/* <div className="helper">{t('emailDescription')}</div> */}
                    <div className="text-danger">
                        {t(errors.officer1?.email?.message)}
                    </div>
                </div>
            </div>
           
        </div>
    )
}